// Copyright (c) Proto Labs, Inc. All Rights Reserved.
export class TokenManagerFetchInterceptor {
    constructor(tokenManager, logger, urlUtility, unauthenticatedDomains, registerGlobalFetch = true) {
        this.RetryStatusList = [401, 403];
        this.unauthenticatedDomains = [];
        this.originalFetch = window.fetch;
        this.tokenManager = tokenManager;
        this.logger = logger;
        this.urlUtility = urlUtility;
        this.unauthenticatedDomains = unauthenticatedDomains;
        if (registerGlobalFetch) {
            window.fetch = async (input, init) => window.tokenManagerFetchInterceptor.fetch(input, init);
        }
    }
    async fetch(input, init) {
        const url = input.url
            ? input.url.toLowerCase()
            : input.toString().toLowerCase();
        // The connect/ and .well-known paths are used by signinSilentAsync() during the token renewal process. They should not have an Authentication header.
        if (!this.tokenManager.isAuthenticated() ||
            (this.tokenManager.renewingToken &&
                (url.endsWith('connect/token') ||
                    url.endsWith('connect/userinfo') ||
                    url.endsWith('.well-known/openid-configuration'))) ||
            !this.urlUtility.isAuthenticatedDomain(input.toString(), this.unauthenticatedDomains)) {
            this.logger.info(`TokenManagerFetchInterceptor.fetch: unauthenticated or route designated as unauthenticated; skipping intercept for '${input}'.`);
            return this.originalFetch.call(window, input, init);
        }
        return this.fetchWithAuth(input, init);
    }
    async fetchWithAuth(input, init) {
        this.logger.info(`TokenManagerFetchInterceptor.fetchWithAuth: attempting fetch to route '${input}' with authentication header.`);
        const newInit = await this.prepareAuthenticatedRequestInit(init);
        let response = await this.originalFetch.call(window, input, newInit);
        if (this.RetryStatusList.includes(response.status)) {
            this.logger.warn(`TokenManagerFetchInterceptor.fetchWithAuth: retrying request due to HTTP ${response.status} response.`);
            response = await this.originalFetch.call(window, input, newInit);
        }
        return response;
    }
    async prepareAuthenticatedRequestInit(init) {
        init = init || {};
        init.headers = init.headers || {};
        let token = await this.tokenManager.getAccessTokenAsync(false);
        if (!token) {
            token = await this.tokenManager.getAccessTokenAsync(true);
            if (!token) {
                this.logger.error('TokenManagerFetchInterceptor.prepareAuthenticatedRequestInit: failed to get access token even after a forced refresh');
                return init;
            }
        }
        // @ts-ignore
        init.headers['Authorization'] = token ? `Bearer ${token}` : null;
        return init;
    }
}
//# sourceMappingURL=TokenManagerFetchInterceptor.js.map